import { render } from "./BilletterieInscriptionThead.vue?vue&type=template&id=420a1d56&scoped=true"
import script from "./BilletterieInscriptionThead.vue?vue&type=script&lang=js"
export * from "./BilletterieInscriptionThead.vue?vue&type=script&lang=js"

import "./BilletterieInscriptionThead.vue?vue&type=style&index=0&id=420a1d56&scoped=true&lang=css"

import exportComponent from "D:\\Downloads\\nm_sportips-inscriptions-main\\nm_sportips-inscriptions-main\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-420a1d56"]])

export default __exports__